export const ORGANISATION_CONFIG_LIST_ALLOWED_SHIPPING_COUNTRIES_NAME =
  'allowed_shipping_countries'

export const ORGANISATION_CONFIG_LIST_ALLOWED_SHIPPING_COUNTRIES_ATT_NAME =
  'allowed-shipping-countries'

export const ORGANISATION_CONFIG_LIST_EXTERNAL_CASE_ID = 'ext_case_id'
